/** One picture from the library, in its colour, on its ground if it has one. */

import type { IconWire } from '@inverse/protocol';
import { GLYPHS } from './glyphs';

export function Glyph({ icon, className }: { icon: IconWire; className?: string }): JSX.Element {
  const drawn = GLYPHS[icon.glyph] ?? GLYPHS.orb;
  return (
    <span
      className={className ? `glyph ${className}` : 'glyph'}
      style={{ color: icon.colour, background: icon.ground }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 24 24">{drawn}</svg>
    </span>
  );
}
